export enum GtmEvent {
  PAGE_VIEW = 'page_view',
  CLICK_EVENT = 'click_event'
}

export interface GtmTag {
  event: GtmEvent;
  pageName?: string;
  eleName?: string;
}
